import React from 'react'

const paraStyle = {
    fontSize: 'large',
    clear: 'both'
};

const divStyle = {
    border: 'none',
    borderBottom: '1px dashed #000',
    width: 'auto'
};

const dateStyle = {
    color: '#f00'
};

class Article extends React.Component {
    render() {
        return (
            <div style={divStyle}>
                <h2><strong>{this.props.title}</strong></h2>
                <p style={paraStyle}>{this.props.content}</p>
                <h5 style={dateStyle}><strong>{this.props.date}</strong></h5>
            </div>
        )
    }
}

export default Article